<template>
  <div id="app" :style="themeColor" class="vh-100">
    <router-view/>
    <Popup
      :isOpen.sync="popUp.isOpen"
      :isLarge="popUp.isLarge"
      :title="popUp.title"
      :content="popUp.content"
      :mode="popUp.mode"
      :cancelWording="popUp.cancelWording"
      :confirmWording="popUp.confirmWording"
      :isCustomize="popUp.isCustomize"
      @confirm="popUp.confirm"
    />
    <Alert ref="alert" :title="alertShow.title" :context="alertShow.context" :variant="alertShow.variant" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import Popup from '@/components/Popup.vue';
import Alert from '@/components/Alert.vue';

export default {
  components: {
    Popup,
    Alert,
  },
  data() {
    return {
      // popup設定
      popUp: {
        // 是否開啟
        isOpen: false,
        // 是否大型
        isLarge: false,
        // 標題
        title: '',
        // 內容
        content: '',
        // 顯示模式
        mode: '',
        // 取消按鈕文案
        cancelWording: '',
        // 確認按鈕文案
        confirmWording: '',
        // 確認事件
        confirm() {},
      },
      // Alert設定
      alertShow: {
        // 標題
        title: '',
        // 內容
        context: '',
        // 顏色
        variant: '',
        // 倒數秒數
        dismissSec: 0,
      },
    };
  },
  computed: {
    ...mapState(['themeColor', 'companyId']),
  },
  watch: {
    companyId() {
      this.setAxiosRequestInterceptors();
    },
  },
  beforeCreate() {
    sessionStorage.removeItem('_gateteway_t');
  },
  created() {
    if (this.companyId) {
      this.setAxiosRequestInterceptors();
    }
    axios.interceptors.response.use((response) => response, (error) => {
      if (error.config.url === '/sso/post/api/v1/apiauth') {
        this.$router.push({ name: 'Error' });
      }
      throw error;
    });
  },
  provide() {
    return {
      openPopUp: this.openPopUp,
      openAlert: this.openAlert,
    };
  },
  methods: {
    // 開啟PopUp
    openPopUp(options) {
      this.popUp = options;
    },
    // 開啟Alert
    openAlert(options) {
      this.alertShow = options;
      this.$refs.alert.dismissSec = options.dismissSec;
    },
    setAxiosRequestInterceptors() {
      axios.interceptors.request.use((config) => {
        if (config.url === '/sso/get/api/v1/apiauth') {
          config.url = `${config.url}?companyId=${this.companyId}`;
        }

        if (config.url === '/sso/post/api/v1/apiauth') {
          config.data = JSON.stringify({ companyId: this.companyId });
        }

        return config;
      });
    },
  },
};
</script>

<style>
div.vh-100 {
  height: calc(var(--vh, 1vh) * 100) !important;
}
</style>
